// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__LCgaP","link":"styles_link__CNkrU","text":"styles_text__OfPBS","checkbox":"styles_checkbox__GB5db"};